import Button from '@shared/components/core/button/CoreButton';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useTranslation } from 'react-i18next';

export default function OrgBillingRedirectErrorContent() {
    const { currentOrg } = useCurrentOrgDetailsFetching();
    const { t } = useTranslation();

    if (!currentOrg) return null;

    return (
        <Button href={'https://cephable.com/individual-pricing/'} target="_blank" rel="noopener noreferrer">
            {t('common:upgrade')}
        </Button>
    );
}
